import { FC } from 'react';
import styles from './ToggleSwitch.module.scss';
import { ToggleGroupProvider, useToggleGroup } from './ToggleGroupContext';
import cx from 'classnames';

export interface ToggleGroupProps {
  options: any;
  disabled: boolean;
  connectValue: any;
}

export interface ToggleSwitchProps {
  name: string;
  label: string;
  disabled: boolean;
  connectValue: any;
}

export const Toggle: FC<ToggleSwitchProps> = ({ name, label, disabled, connectValue }) => {
  // @ts-ignore
  const { selected, setSelected } = useToggleGroup();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelected(event.target.name);
    } else {
      setSelected(null);
    }

    connectValue(event.target.checked ? event.target.name : null);
  };
  return (
    <div className={cx(styles.toggleSwitch, { [styles['toggleSwitch--disabled']]: disabled })}>
      <input
        type='checkbox'
        disabled={disabled}
        className={styles.toggleSwitch__input}
        name={name}
        id={name}
        checked={selected === name}
        onChange={handleChange}
      />
      <label className={styles.toggleSwitch__label} htmlFor={name}>
        <span className={styles.toggleSwitch__track} />
        <span className={styles.toggleSwitch__thumb} />
      </label>
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
};

const ToggleGroup: FC<ToggleGroupProps> = ({ options, disabled, connectValue }) => {
  return (
    <ToggleGroupProvider>
      {options.map((opt: any) => (
        <Toggle connectValue={connectValue} key={opt.name} name={opt.name} label={opt.label} disabled={disabled} />
      ))}
    </ToggleGroupProvider>
  );
};
export default ToggleGroup;
